import { HttpClient } from "@angular/common/http";
import { BaseService } from "./base.service";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "./auth.service";
import { IPortalSubscription } from "../interfaces/iportalsubscription";
import { Observable } from "rxjs";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { Injectable } from "@angular/core";

@Injectable()
export class PortalSubscriptionService extends BaseService {
    /**
     *
     */
    constructor(http: HttpClient, toastr: ToastrService, authService: AuthService, private applicationSettings: ApplicationSettingsService) {
        super(http, authService, toastr);
    }

    createUpdate(portalSubscription: IPortalSubscription): Observable<number> {
        return super.post(`${this.applicationSettings.apiUrl}PortalSubscription`, portalSubscription);
    }

    Delete(email: string): Observable<boolean> {
        return super.delete(`${this.applicationSettings.apiUrl}PortalSubscription`, email);
    }

    GetSubscription(email: string): Observable<IPortalSubscription> {
        return super.get(`${this.applicationSettings.apiUrl}PortalSubscription/${email}`);
    }
}